<template>
  <div class="buy">
    <Header />
    <div class="body-buy">
      <Slider />
      <div class="content-buy">
        <Title />
        <CodeAndControls @typePackege="typePackege" />
        <SalesPackages v-if="activeSection" @selectplan="selectplan" :type="type" />
        <DataAndPayment v-else />
      </div>
    </div>
    <ModalSucess :show="false" />
    <Footer />
  </div>
</template>
<script>
export default {
  name: 'Buy',
  components: {
    Slider: () => import('@/components/Sections/Buy/Slider'),
    Header: () => import('@/components/Sections/Buy/Header'),
    Title: () => import('@/components/Sections/Buy/Title'),
    ModalSucess: () => import('@/components/Modals/SuccesPayment'),
    CodeAndControls: () => import('@/components/Sections/Buy/CodeAndControls'),
    SalesPackages: () => import('@/components/Sections/Buy/SalesPackages'),
    Footer: () => import('@/components/Sections/Buy/Footer'),
    DataAndPayment: () => import('@/components/Sections/Buy/DataAndPayments'),
  },
  data() {
    return { activeSection: true, typePlanSelected: '', type: false };
  },
  computed: {},
  watch: {},
  methods: {
    selectplan(type) {
      this.activeSection = false;
      this.typePlanSelected = type;
    },
    typePackege(type) {
      this.type = type;
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style>
html {
  background: white !important;
}
</style>
<style lang="scss" scoped>
.body-buy {
  width: 100%;
  height: auto;
  position: relative;
}
.content-buy {
  width: 1095px;
  height: auto;
  position: absolute;
  top: 120px;
  left: 0;
  right: 0;
  z-index: 4;
  margin-left: auto;
  margin-right: auto;
  @media screen and (max-width: 1115px) {
    width: 995px;
    // background: rgb(255, 0, 234);
  }
  @media screen and (max-width: 1015px) {
    width: 895px;
    // background: rgb(255, 251, 0);
  }
  @media screen and (max-width: 915px) {
    width: 795px;
    // background: rgb(255, 94, 0);
  }
  @media screen and (max-width: 815px) {
    width: 748px;
    // background: rgb(255, 0, 0);
  }
  @media screen and (max-width: 768px) {
    width: 708px;
    // background: rgb(129, 1, 76);
  }
  @media screen and (max-width: 480px) {
    width: 100%;
    // background: rgb(157, 255, 132);
  }

  @media screen and (max-width: 715px) {
    width: 96%;
    // background: rgb(3, 44, 54);
  }
  @media screen and (max-width: 360px) {
    top: 120px;
  }
  @media screen and (max-width: 340px) {
    top: 110px;
  }
  @media screen and (max-width: 320px) {
    top: 100px;
  }
}
</style>
